export default __webpack_public_path__ + "static/media/google.e1e3e173.svg";